<!-- components/MenuItem.vue -->
<template>
  <div>
    <!-- 有子菜单：渲染 el-submenu -->
    <el-submenu v-if="item.children" :index="item.index">
      <template slot="title">
        <span style="font-size:14px;">{{ item.title }}</span>
      </template>
      <!-- 递归渲染子菜单 -->
      <menu-item
          v-for="child in filteredChildren"
          :key="child.index"
          :item="child"
          @menu-click="$emit('menu-click', $event)"
      />
    </el-submenu>

    <!-- 无子菜单：渲染 el-menu-item -->
    <el-menu-item
        v-else
        :index="item.index"
        @click="handleClick"
    >
      <!-- 外部链接特殊处理 -->
      <a
          v-if="item.isExternal"
          :href="item.href()"
          slot="title"
          style="color: #000;"
          target="_blank"
      >
        {{ item.title }}
      </a>
      <!-- 普通菜单 + 评图徽章 -->
      <span v-else slot="title" :style="item.title === '评图' ? 'line-height: 20px;' : ''">
        {{ item.title }}
        <label
            v-if="item.hasBadge && img_num > 0"
            style="margin-left: 60px;margin-top: -5px;color:#d34579"
        >
          {{ img_num }}
        </label>
      </span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    item: { type: Object, required: true }, // 单个菜单项配置
    userRole: { type: [Number, String], required: true }, // 当前用户角色
    img_num: { type: Number, default: 0 } // 评图徽章数量
  },
  methods: {
    handleClick() {
      this.$emit('menu-click', this.item.index); // 触发菜单点击事件
    }
  },
  computed: {
    // 过滤子菜单：只显示当前角色有权限的
    filteredChildren() {
      return this.item.children.filter(child => child.role
          ? child.role.includes(this.userRole)
          : true // 子菜单未指定role则默认显示
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Menu.vue